<template>
    <router-link :to="to" :title="expanded ? null : title"
        class="tw:flex tw:items-center tw:gap-3 tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:no-underline tw:transition-all"
        :class="active
            ? 'tw:bg-brand-primary/15 tw:text-brand-primary tw:font-semibold'
            : 'tw:font-medium tw:text-slate-400 tw:hover:bg-slate-800/70 tw:hover:text-slate-200'">
        <i :class="icon" class="tw:text-sm tw:w-4 tw:shrink-0 tw:text-center"></i>
        <span class="tw:truncate" v-show="expanded">{{ title }}</span>
    </router-link>
</template>

<script>
export default {
    name: 'SidebarLink',
    props: {
        to: { type: [String, Object], required: true },
        icon: { type: String, default: '' },
        title: { type: String, default: '' },
        active: { type: Boolean, default: false },
        expanded: { type: Boolean, default: true },
    },
}
</script>
